<div class="animated fadeIn">
    
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body" style="min-height: 600px;">
                    <!-- <h4 class="box-title">Login Audit List </h4>
                    <br/> -->
                    <div class="row form-group" >
                        <div class="col col-md-12">
                            <div class="card border border-success">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <strong class="card-title">Login Audit Search</strong>  
                                        </div>
                                        <div class="col col-md-3">
                                            <input name="email" [(ngModel)]="email" placeholder="User ID" id="email" class="form-control-sm form-control"  />
                                        </div>
                                        <div class="col col-md-3">
                                            <select name="status" id="status" class="form-control-sm form-control" [(ngModel)]="status">
                                                <option  value="">Select Status</option>
                                                <option value="0">Failed</option>
                                                <option value="1">Success</option>   
                                            </select>
                                        </div>
                                        <div class="col col-md-3">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="searchLoginAudit(1)" >Search</button>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="card-body" > 
                                    <div class="row form-group">
                                        <div class="col col-md-4">
                                            <label for="userRole" class=" form-control-label">
                                                <strong>User ID</strong>
                                            </label>
                                        </div>
                                        <div class="col col-md-4">
                                            <label for="companyName" class=" form-control-label">
                                                <strong>Status</strong>
                                            </label>
                                        </div>
                                        <div class="col col-md-4">
                                            &nbsp;
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col col-md-4">
                                            <input name="email" [(ngModel)]="email" id="email" class="form-control-sm form-control"  />
                                        </div>
                                        <div class="col col-md-4">
                                            <select name="status" id="status" class="form-control-sm form-control" [(ngModel)]="status">
                                                <option  value="">Select Status</option>
                                                <option value="0">Failed</option>
                                                <option value="1">Success</option>   
                                            </select>
                                        </div>
                                        <div class="col col-md-4">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="searchLoginAudit(1)" >Search</button>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                        <thead>
                            <tr role="row">
                                <th >User ID</th>
                                <th>Status</th>
                                <th>Timestamp</th>
                                <!-- <th>User Agent</th> -->
                            </tr>
                        </thead>
                        <tbody> 
                            <tr role="row" class="odd" *ngFor="let ld of laData">
                                <td class="sorting_1">{{ld.email}}</td>
                                <td>{{ld.status==0?"Failed":"Success"}}</td>
                                <td>{{ld.createDate| date:'dd-MM-yyyy HH:mm:ss'}}</td>
                                <!-- <td>{{ld.otherInfo}}</td> -->
                            </tr> 
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-5">
                    <div class="dataTables_info" id="bootstrap-data-table_info" role="status" aria-live="polite">Showing {{(curPage-1)*perPageRow+1}} to {{(curPage-1)*perPageRow+noOfRows}} of {{totalRows}}</div>
                </div>
                <div class="col-sm-12 col-md-7">
                    <div class="dataTables_paginate paging_simple_numbers" id="bootstrap-data-table_paginate">
                        <ul class="pagination" style="max-width:200px; word-wrap:break-word;">
                           <li class="paginate_button page-item previous" id="bootstrap-data-table_previous" (click)="previous()" [hidden]="curPage ==1 ? true : false">
                                <a  aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0" class="page-link btn btn-primary" style="width: 100px;">Previous</a>
                            </li>
                            
                            <li class="paginate_button page-item next" id="bootstrap-data-table_next" (click)="next()" >
                                <a  aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0" class="page-link btn btn-primary" style="width: 100px;">Next</a>
                            </li>

                            <!-- <li class="paginate_button page-item {{item==curPage?'active':''}}" *ngFor="let item of pages; let i = index" (click)="searchLoginAudit(item)">
                                <a  aria-controls="bootstrap-data-table"  class="page-link">{{item}}</a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div><!-- .animated -->

